import {
  ButtonComponent,
  DividerComponent,
  TextFieldComponent,
} from "@/components";
import React from "react";
import {
  CurrencyConverter,
  IMAGES,
  MOBILE_REGEX,
  WEB_COLORS,
} from "@/lib/constants";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Image from "next/image";
import { useTranslations } from "next-intl";
const CheckEligibilityRightCard = ({
  formik,
  handleFieldChange,
  isError,
  errorMessage,
}) => {
  const t = useTranslations("Login");
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Stack
      m={{ xs: 1 }}
      px={2}
      gap={2}
      flexGrow={1}
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Typography variant="h3" fontSize={{ xs: 14, sm: 30 }}>
        {t("phonenumber")}
      </Typography>
      <TextFieldComponent
        shrink
        type="number"
        name="phone"
        maxLength={10}
        label={t("phone")}
        value={formik?.values?.phone}
        placeholder={t("phone")}
        errorMessage={formik?.errors?.phone}
        error={Boolean(formik?.touched?.phone && formik?.errors?.phone)}
        success={Boolean(formik?.touched?.phone && !formik?.errors?.phone)}
        onBlur={formik.handleBlur}
        onChange={(e) => {
          handleFieldChange(e, MOBILE_REGEX);
        }}
        size={`${isBelowMd ? "small" : ""}`}
      />
      <ButtonComponent
        toolTipTitle={t("loginttoltip")}
        type="submit"
        onClick={formik.handleSubmit}
        disabled={!(formik.isValid && formik.dirty)}
        size={`${isBelowMd ? "small" : ""}`}
      >
        {t("getotp")}
      </ButtonComponent>
      {/* <ButtonComponent
        toolTipTitle={t("loginttoltip")}   
      >
        {t("getotp")}
      </ButtonComponent> */}
      <Stack width={"100%"}>
        <FormControlLabel
          control={
            <Checkbox
              name="terms"
              checked={formik.values.terms}
              onChange={formik.handleChange}
            />
          }
          label={
            <Typography color={WEB_COLORS.textFadeColor} fontSize={14}>
              {t("termsandconditions")}{" "}
              <a
                className="doc-link"
                href={process.env.NEXT_PUBLIC_TERMS_AND_CONDITIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("terms")}
              </a>{" "}
              {t("and")}{" "}
              <a
                className="doc-link"
                href={process.env.NEXT_PUBLIC_PRIVACY_POLICY_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("privacy")}
              </a>{" "}
              {t("consent")}
            </Typography>
          }
        />

        <FormControlLabel
          control={
            <Checkbox
              name="whatsapp"
              checked={formik.values.whatsapp}
              onChange={formik.handleChange}
            />
          }
          label={
            <Typography
              color={WEB_COLORS.textFadeColor}
              fontSize={14}
              sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
            >
              {t("whatsapp")}{" "}
              <Image
                src={IMAGES.whatsApp}
                alt="whatsApp"
                height={25}
                width={25}
              />
            </Typography>
          }
        />
      </Stack>
    </Stack>
  );
};

export default CheckEligibilityRightCard;
